<style>
/* .dropdown-menu {   
}
*/
#ddl_blockid ul{
    margin:0 0 0 13px;
    list-style: none;
}
#ddl_blockid { 
  line-height: 1rem;   /* controls text line spacing */   
    display: block !important;
    border: solid 0.5px grey;
    max-height: 150px; 
    max-width: 10px;
    overflow-y: auto;
}
</style>
<script setup>
import ArgonInput from "@/components/ArgonInput.vue";
</script>
<template>
    <div ref="dropdownRef">

  <argon-input
        placeholder="Type here..."
        icon="ni ni-bullet-list-67" v-model="inputText"
        iconDir="right" @click="toggleDropdown" id="input_ddl_checkbox"  />
    <div v-show="isShow" >
        <div id="ddl_blockid" class="dropdown-menu" style="max-width:250px">
            <ul class="list-none p-0" >
                <li>
                    <button type="button" class="btn-success me-3" @click="checkAllList(true)"> Check</button><button type="button" class="btn-primary" @click="checkAllList(false)" >Uncheck</button>
                </li>
                <hr />
                <li v-for="option in list" :key="option.text" :value="option.text"   >
                    <label class="flex items-center cursor-pointer"><input id="chk" :checked="selectedValue.includes(option.text)"  type="checkbox" @click="showSelectedValue(option.text)" :value="option.value" /> {{ option.text }} - {{ option.value }}</label>
                </li>
            </ul>
        </div>
    </div>
    
</div>
</template>

<script>

export default {
  name:'sawitBuahCreate',
  props: {
    list: {
      type: Array,
      required: true
    },
    modelValue: {
      type: String, // assuming multiple selections
      default: () => ""
    }
  },
  data(){
    return {
        isShow: false,
        text:"test",
        dropdownRef:null,
        selectedValue: [],
        inputText: "",
    }
  },
  mounted(){
    document.addEventListener("click", this.handleClickOutside);
  },
  onBeforeUnmount(){
    document.removeEventListener("click", this.handleClickOutside);
  },
  watch: {
    // when parent resets modelValue (e.g. ""), clear selectedValue
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.selectedValue = newVal ? newVal.split(",") : [];
        this.inputText = newVal; // also sync with input text
      },
    },
    inputText(newVal) {
      // if user types manually, update parent
      this.$emit("update:modelValue", newVal);
    },
  },
  emits: ["update:modelValue"],
  methods: {
    handleClickOutside(event) {
    if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
        this.isShow = false;
    }
    },
    toggleDropdown(){
        this.isShow = !this.isShow;
    },
    checkAllList(option){
      if(option){
        this.selectedValue = this.list.map((o) => o.text);
      }else{
        this.selectedValue = [];
      }
      this.inputText = this.selectedValue.join(","); // ✅ sync input
      this.$emit("update:modelValue", this.inputText);
    },
    showSelectedValue(id){
        if (this.selectedValue.includes(id)) {
            this.selectedValue = this.selectedValue.filter(x => x !== id);
        } else {
            this.selectedValue.push(id);
        }
      this.inputText = this.selectedValue.join(","); // ✅ sync input
      this.$emit("update:modelValue", this.inputText);
    }
  },
}
</script>